import { NgModule } from '@angular/core';

import { AccordionModule } from './accordion/accordion.module';
import { CommonUIModule } from './common-ui/common-ui.module';
import { FilterModule } from './filter/filter.module';
import { JumbotronModule } from './jumbotron/jumbotron.module';
import { ListModule } from './list/list.module';
import { PanelModule } from './panel/panel.module';
import { TileModule } from './tile/tile.module';

@NgModule({
  exports: [
    AccordionModule,
    CommonUIModule,
    FilterModule,
    JumbotronModule,
    ListModule,
    PanelModule,
    TileModule,
  ],
  imports: [
    AccordionModule,
    CommonUIModule,
    FilterModule,
    JumbotronModule,
    ListModule,
    PanelModule,
    TileModule,
  ],
})
export class SharedUiModule {}
